<script>
    export let tagCounts;
    export let filterTags;
    export let selectedTags;

    function tagId(tag) {
        return `filter-tag-${tag}`.toLowerCase().replace(/\W+/g, " ");
    }
</script>

<div class="tagContainer">
    {#each filterTags as tagSection}
        <div class="tagFilter">
            <h4 class="title">{tagSection.title}</h4>
            <div class="fields">
                {#each tagSection.tags as tag}
                    <label
                        class:empty={!tagCounts[tag]}
                        class:selected={selectedTags.includes(tag)}
                        for={tagId(tag)}
                    >
                        <span class="input">
                            <input
                                type="checkbox"
                                bind:group={selectedTags}
                                name="selectedTags"
                                value={tag}
                                id={tagId(tag)}
                            />
                        </span>
                        <span class="text"
                            >{tag} ({tagCounts[tag] ? tagCounts[tag] : 0})</span
                        >
                    </label>
                {/each}
            </div>
        </div>
    {/each}
</div>
